import React, { useState, useEffect, useCallback, useContext } from 'react'
import { DomainContext } from '../../domain-repository/DomainRepository'

import './LegalInformation.css'

import LegalInformationPage from './LegalInformationPage'

function LegalInformation(props) {
  const {
    label,
    driverInfoVerified, setDriverInfoVerified, driverInfoVerifiedLabel,
    policyAndTermsVerified, setPolicyAndTermsVerified, policyAndTermsLabel, policyLabel, termsLabel,
    history, search, state, pageUrl
  } = props

  useEffect(() => {
    if (state?.verified && !policyAndTermsVerified) {
      setPolicyAndTermsVerified(true)
    }
    if (!policyAndTermsVerified && !state?.verified) {
      props.history.push({ pathname: '/terms-conditions', search, state })
    }
  }, [])

  const handleTermsConditionsClick = useCallback(() => {
    props.history.push({ pathname: '/terms-conditions', search, state: { ...state, privacyReturnTo: pageUrl, view: 'read' } })
  }, [state, pageUrl])

  return (
    <div className='legal-info'>
      <div className='legal-info__label'>{label}</div>
      <div className='legal-info__actions'>
        <PopupLabelCheckbox
          label={policyAndTermsLabel}
          value={policyAndTermsVerified}
          onChange={() => { }}
        >
          <div className='legal-info__policy-and-terms'>
            <span className='legal-info__policy-and-terms-item' onClick={handleTermsConditionsClick}>{termsLabel}</span>
            <span>/</span>
            <span className='legal-info__policy-and-terms-item' onClick={handleTermsConditionsClick}>{policyLabel}</span>
          </div>
        </PopupLabelCheckbox>
        <SimpleCheckbox value={driverInfoVerified} onChange={setDriverInfoVerified} label={driverInfoVerifiedLabel} />
      </div>
    </div>
  )
}

export default LegalInformation

export function TermsConditionsPage(props) {

  const [readOnly, setReadOnly] = useState(false)

  useEffect(() => {
    setReadOnly(props.location?.state?.view === 'read' || false)
  }, [])

  const handleAcceptClick = useCallback(() => {
    props.history.push({
      pathname: props.location.state?.privacyReturnTo || '/driver-info-review',
      search: props.location.search,
      state: { ...props.location.state, verified: true }
    })
  }, [props.location])

  const handleRejectClick = useCallback(() => {
    props.history.push('/start')
  }, [])

  const handleCloseClick = useCallback(() => {
    props.history.push({
      pathname: props.location.state?.privacyReturnTo || '/driver-info-review',
      search: props.location.search,
      state: props.location.state 
    })
  }, [props.location])

  return (
    <LegalInformationPage
      handleLogoClick={() => props.history.push('/start')}
      handleCloseClick={handleCloseClick}
      terms={true}
      pageId={73}
      handleAcceptClick={handleAcceptClick}
      handleRejectClick={handleRejectClick}
      readOnly={readOnly}
    />
  )
}

export function SimpleCheckbox({ value, onChange, label }) {

  return (
    <div className="legal-info__actions-item">
      <input
        className="legal-info__actions-item__checkbox"
        type="checkbox"
        name="consent"
        checked={value}
        onChange={e => onChange(e.target.checked)}
      />
      <span
        className="legal-info__actions-item__correct-info-text"
        onClick={() => onChange(!value)}
      >
        {label}
      </span>
    </div>
  )
}

function PopupLabelCheckbox({ value, onChange, label, children }) {
  return (
    <div className="legal-info__actions-item legal-info__actions-item--3">
      <input
        className="legal-info__actions-item__checkbox"
        type="checkbox"
        name="consent"
        checked={value}
        onChange={e => onChange(e.target.checked)}
      />
      <span
        className="legal-info__actions-item__correct-info-text"
        onClick={() => onChange(!value)}
      >
        {label}
      </span>
      {children}
    </div>
  )
}
